async function getCloudflareCountryCode() {
  try {
    let data = await fetch('https://1.1.1.1/cdn-cgi/trace').then(res => res.text());

    let arr = data
      .trim()
      .split('\n')
      .map(e => e.split('='));

    const object = Object.fromEntries(arr);

    const { loc: country } = object;

    return country;
  } catch (error) {
    console.error('Error fetching cloudflare country code', error);
    return null;
  }
}

export { getCloudflareCountryCode };
